import React from 'react';
import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import NavBarCopy from '../../copy/NavBarCopy';
import Menu from './components/Menu.js';

export const PlansAndPricingMenu = () => {
  const path = createURL('https://help.surveymonkey.com/', {
    ut_source: 'megamenu',
  });

  const key = 'Plans & Pricing';
  const keyLookup = 'PLANS_AND_PRICING';
  const menuTitle = t(NavBarCopy[keyLookup]);

  return (
    <Menu title={menuTitle} path={path} menuKey={key}>
      <div />
    </Menu>
  );
};

export default PlansAndPricingMenu;
